import React, {useEffect, useState} from "react";
import {Table, Input, InputNumber, Button, Form, Typography, Popconfirm} from "antd";
import {useTranslation} from "react-i18next";

const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
}) => {
    const {t} = useTranslation([]);

    const placeholderByDataIndex = {
        color: "Kırmızı, Beyaz vb.",
        size: "L, XL, 30, 32 vb."
    };

    const inputNode =
        inputType === "number" ? (
            <InputNumber min={0} />
        ) : (
            <Input placeholder={placeholderByDataIndex?.[dataIndex] || ""} />
        );
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{marginRight: 0, marginBottom: 0, marginLeft: 0, marginTop: 0}}
                    rules={[
                        {
                            required: true,
                            message: `${t("validation.required", {ns: "common"})}`,
                            type: inputType === "number" ? "number" : "string"
                        }
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};

export const EquipmentVariationsInput = ({
    variations = [],
    setVariations = variations => {},
    refreshInput = false,
    visibility = false
}) => {
    const {t} = useTranslation([]);
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [editingKey, setEditingKey] = useState("");

    const reset = () => {
        setData([]);
        setEditingKey("");
    };
    const isEditing = record => record.key === editingKey;

    const edit = record => {
        form.setFieldsValue({color: "", size: "", price: "", externalId: "", ...record});
        setEditingKey(record.key);
    };

    const cancel = () => {
        const editingRowOldData = data.find(item => item.key === editingKey);
        if (editingRowOldData.color === "" || editingRowOldData.size === "") {
            data.pop();
            setData([...data]);
        }

        setEditingKey("");
    };

    const save = async key => {
        try {
            const row = await form.validateFields();
            const newData = [...data];
            const index = newData.findIndex(item => key === item.key);
            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, {...item, ...row});
                setData(newData);
                setEditingKey("");
                setVariations(newData);
            } else {
                newData.push(row);
                setData(newData);
                setEditingKey("");
                setVariations(newData);
            }
        } catch (errInfo) {
            console.log("Validate Failed:", errInfo);
        }
    };

    const handleAdd = () => {
        const newData = {
            key: data.length,
            color: "",
            size: "",
            price: 0,
            externalId: ""
        };
        setData([...data, newData]);
        edit(newData);
        /* setVariations([...data, newData]); */
    };

    const handleDelete = key => {
        const newData = data.filter(item => item.key !== key);
        setData(newData);
        setVariations(newData);
    };

    const columns = [
        {
            title: "Renk",
            dataIndex: "color",
            width: "25%",
            editable: true
        },
        {
            title: "Beden",
            dataIndex: "size",
            width: "25%",
            editable: true
        },
        {
            title: "Fiyat",
            dataIndex: "price",
            width: "25%",
            editable: true
        },
        {
            title: "External ID",
            dataIndex: "externalId",
            width: "25%",
            editable: true
        },
        {
            title: "",
            dataIndex: "operation",
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Typography.Link onClick={() => save(record.key)} style={{marginRight: 8}}>
                            Kaydet
                        </Typography.Link>
                        <Popconfirm title="Emin misiniz?" onConfirm={cancel}>
                            <a>İptal</a>
                        </Popconfirm>
                    </span>
                ) : (
                    <span>
                        <Typography.Link disabled={editingKey !== ""} onClick={() => edit(record)}>
                            Düzenle
                        </Typography.Link>
                        <Popconfirm
                            title="Emin misiniz?"
                            onConfirm={() => handleDelete(record.key)}
                        >
                            <a style={{marginLeft: 8}}>Sil</a>
                        </Popconfirm>
                    </span>
                );
            }
        }
    ];

    const mergedColumns = columns.map(col => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: record => ({
                record,
                inputType: col.dataIndex === "price" ? "number" : "text",
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record)
            })
        };
    });

    useEffect(() => {
        setData(
            variations.map((variation, index) => ({
                key: index,
                color: variation.color,
                size: variation.size,
                price: variation.price,
                externalId: variation.externalId
            }))
        );
        if (!visibility) {
            reset();
        }
    }, [refreshInput, visibility]);

    return (
        <Form form={form} component={false}>
            <Table
                components={{
                    body: {
                        cell: EditableCell
                    }
                }}
                bordered
                dataSource={data}
                columns={mergedColumns}
                rowClassName="editable-row"
                pagination={false}
                rowKey={record => record.key}
            />
            <Button
                disabled={editingKey !== ""}
                onClick={handleAdd}
                type="primary"
                style={{
                    marginTop: "16px"
                }}
            >
                Yeni Varyasyon Ekle
            </Button>
        </Form>
    );
};
